var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineCircle = function SvgLineCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "line-circle_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.115 12c0 .918-.107 1.812-.307 2.67-1.207 5.156-5.835 8.997-11.36 8.997s-10.153-3.84-11.36-8.998c-.2-.857-.307-1.75-.307-2.67C.781 5.558 6.005.334 12.448.334S24.115 5.557 24.115 12"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.448 10.333.297-.778a.83.83 0 0 0-.594 0zM1.385 15.448l11.36-4.336-.594-1.557L.79 13.89zm10.766-4.336 11.36 4.336.594-1.557-11.36-4.336zm-.536-.779v13.334h1.666V10.333zM1.088 14.67l1.623-.38zm22.72 0-1.623-.38zM2.448 12c0-5.522 4.477-10 10-10v-3.332C5.084-1.333-.885 4.637-.885 12zm10-10c5.523 0 10 4.478 10 10h3.333c0-7.363-5.97-13.332-13.333-13.332zm0 20c-4.734 0-8.702-3.29-9.737-7.71l-3.246.76c1.38 5.894 6.667 10.284 12.983 10.284zM2.71 14.29c-.172-.733-.263-1.5-.263-2.29H-.885c0 1.048.12 2.07.35 3.05zM22.448 12c0 .79-.091 1.557-.263 2.29l3.246.76c.23-.98.35-2.002.35-3.05zm-.263 2.29C21.15 18.71 17.181 22 12.448 22v3.334c6.316 0 11.603-4.39 12.983-10.284z",
    mask: "url(#line-circle_svg__a)"
  })));
};
export default SvgLineCircle;